<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible="visible"
      :title="$t('SeaExport.WithdrawalOfDocumentStatus')"
      width="380px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
      @close="cancel"
    >
      <div>
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('SeaExport.DocumentStatus')">
            <el-select v-model="fileState">
              <el-option
                v-for="item in dateTypes"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DocumentDate')">
            <el-date-picker
              v-model="selectDate"
              type="date"
              :editable="false"
              :clearable="false"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button type="primary" @click="circulationFileHandler">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { rollbackStateFunc } from '@/api/seaExport/file'
import $store from '@/store'
import { YGD_TYPE, YJD_TYPE, YQH_TYPE, YSC_TYPE, YTH_TYPE, YTS_TYPE } from '@/class/cargo/model/parameters/FileState'

export default {
  name: 'RollbackWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    files: { type: Array, required: true }
  },
  data() {
    return {
      loading: false,
      fileState: 1,
      selectDate: new Date(),
      dateTypes: [
        { name: this.$t('SeaExport.SendOut'), code: 1 },
        { name: this.$t('SeaExport.Archive'), code: 11 },
        { name: this.$t('SeaExport.RefundTax'), code: 12 },
        { name: this.$t('SeaExport.RetrieveourCompany'), code: 2 },
        { name: this.$t('SeaExport.Returncustomer'), code: 3 }
      ],
      gridApi: null
    }
  },
  computed: {

  },
  async beforeMount() {

  },
  mounted() {},
  methods: {
    cancel() {
      this.$emit('closePage')
    },
    circulationFileHandler() {
      if (!([1, 11, 12, 2, 3]).includes(this.fileState)) {
        this.$message.warning(this.$t('SeaExport.StateNotSelected'))
        return
      }
      if (!this.selectDate) {
        this.$message.warning(this.$t('SeaExport.DateNotSelected'))
        return
      }
      const fileList = []
      for (const file of this.files) {
        file.state = this.fileState
        this.getFileStateDate(file)
        fileList.push(file)
      }
      // 调用后端保存
      rollbackStateFunc(fileList, { type: this.fileState, selectDate: this.selectDate }).then(res => {
        this.$message.success(this.$t('SeaExport.WithdrawalSuccessful'))
        this.$emit('successHandler', fileList)
      })
    },
    getFileStateDate(file) {
      // 送出
      if (this.fileState === YSC_TYPE.code) {
        file.sendDate = this.selectDate
        file.filedDate = null
        file.filedUser = 0
        file.rebatedDate = null
        file.rebatedUser = 0
        file.backDate = null
        file.backUser = 0
        file.returnDate = null
      }
      if (this.fileState === YJD_TYPE.code) {
        // 接单
        file.acceptedDate = new Date()
        file.acceptedUser = $store.getters.userId
        file.filedDate = null
        file.filedUser = 0
        file.rebatedDate = null
        file.rebatedUser = 0
        file.backDate = null
        file.backUser = 0
        file.returnDate = null
      } else if (this.fileState === YGD_TYPE.code) {
        // 归档
        file.filedDate = this.selectDate
        file.filedUser = $store.getters.userId
        file.rebatedDate = null
        file.rebatedUser = 0
        file.backDate = null
        file.backUser = 0
        file.returnDate = null
      } else if (this.fileState === YTS_TYPE.code) {
        // 退税
        file.rebatedDate = this.selectDate
        file.rebatedUser = $store.getters.userId
        file.backDate = null
        file.backUser = 0
        file.returnDate = null
      } else if (this.fileState === YQH_TYPE.code) {
        // 取回
        file.backDate = this.selectDate
        file.backUser = $store.getters.userId
        file.returnDate = null
      } else if (this.fileState === YTH_TYPE) {
        // 退还
        file.returnDate = this.selectDate
      }
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}
</style>

